const MAX_SMS_LENGTH = 160
const MAX_CHARACTERS_LENGTH = 500

const INSTRUCTIONS = {
  REWRITE_COMPLETELY: 'Rewrite the message from scratch, keeping the original intent.',
  MAKE_IT_CLEANER: 'Rewrite the message to improve clarity, without changing meaning.',
  FIX_SPELLING_AND_GRAMMAR: 'Correct grammar and spelling without changing tone or meaning.',
  MAKE_IT_MORE_PROFESSIONAL: 'Rewrite the message to sound more formal and polished.',
  MAKE_IT_MORE_FRIENDLY: 'Make the message sound more friendly and approachable.',
  MAKE_IT_MORE_CONFIDENT: 'Make the message sound more assertive and confident.',
  MAKE_IT_SHORTER: 'Condense the message while keeping its meaning.',
  MAKE_IT_LONGER: 'Expand the message with additional useful context.',
  ADD_MORE_DETAILS: 'Add relevant details to make the message more complete.',
  MAKE_IT_MORE_EXCITING: 'Make the message more lively and enthusiastic.',
}

const getTitles = (t) => ({
  REWRITE_COMPLETELY: t('improve-with-ai:titles.rewriteCompletely'),
  MAKE_IT_CLEANER: t('improve-with-ai:titles.makeItCleaner'),
  FIX_SPELLING_AND_GRAMMAR: t('improve-with-ai:titles.fixSpellingAndGrammar'),
  MAKE_IT_MORE_PROFESSIONAL: t('improve-with-ai:titles.makeItMoreProfessional'),
  MAKE_IT_MORE_FRIENDLY: t('improve-with-ai:titles.makeItMoreFriendly'),
  MAKE_IT_MORE_CONFIDENT: t('improve-with-ai:titles.makeItMoreConfident'),
  MAKE_IT_SHORTER: t('improve-with-ai:titles.makeItShorter'),
  MAKE_IT_LONGER: t('improve-with-ai:titles.makeItLonger'),
  ADD_MORE_DETAILS: t('improve-with-ai:titles.addMoreDetails'),
  MAKE_IT_MORE_EXCITING: t('improve-with-ai:titles.makeItMoreExciting'),
})

const getOptions = (t) => {
  const TITLES = getTitles(t)
  return [
    {
      icon: '/images/emoji/pen.svg',
      title: TITLES.REWRITE_COMPLETELY,
      instruction: INSTRUCTIONS.REWRITE_COMPLETELY,
    },
    {
      icon: '/images/emoji/broom.svg',
      title: TITLES.MAKE_IT_CLEANER,
      instruction: INSTRUCTIONS.MAKE_IT_CLEANER,
    },
    {
      icon: '/images/emoji/wrench.svg',
      title: TITLES.FIX_SPELLING_AND_GRAMMAR,
      instruction: INSTRUCTIONS.FIX_SPELLING_AND_GRAMMAR,
    },
    {
      icon: '/images/emoji/briefcase.svg',
      title: TITLES.MAKE_IT_MORE_PROFESSIONAL,
      instruction: INSTRUCTIONS.MAKE_IT_MORE_PROFESSIONAL,
    },
    {
      icon: '/images/emoji/friendly-face.svg',
      title: TITLES.MAKE_IT_MORE_FRIENDLY,
      instruction: INSTRUCTIONS.MAKE_IT_MORE_FRIENDLY,
    },
    {
      icon: '/images/emoji/target.svg',
      title: TITLES.MAKE_IT_MORE_CONFIDENT,
      instruction: INSTRUCTIONS.MAKE_IT_MORE_CONFIDENT,
    },
  ]
}

const getRewriteOptions = (t) => {
  const TITLES = getTitles(t)
  return [
    {
      icon: '/images/emoji/pen.svg',
      title: TITLES.REWRITE_COMPLETELY,
      instruction: INSTRUCTIONS.REWRITE_COMPLETELY,
    },
    {
      icon: '/images/emoji/wrench.svg',
      title: TITLES.FIX_SPELLING_AND_GRAMMAR,
      instruction: INSTRUCTIONS.FIX_SPELLING_AND_GRAMMAR,
    },
    {
      icon: '/images/emoji/back-arrow.svg',
      title: TITLES.MAKE_IT_SHORTER,
      instruction: INSTRUCTIONS.MAKE_IT_SHORTER,
    },
    {
      icon: '/images/emoji/bidirect-arrow.svg',
      title: TITLES.MAKE_IT_LONGER,
      instruction: INSTRUCTIONS.MAKE_IT_LONGER,
    },
    {
      icon: '/images/emoji/light-bulb.svg',
      title: TITLES.ADD_MORE_DETAILS,
      instruction: INSTRUCTIONS.ADD_MORE_DETAILS,
    },
  ]
}

const getAdjustToneOptions = (t) => {
  const TITLES = getTitles(t)
  return [
    {
      icon: '/images/emoji/briefcase.svg',
      title: TITLES.MAKE_IT_MORE_PROFESSIONAL,
      instruction: INSTRUCTIONS.MAKE_IT_MORE_PROFESSIONAL,
    },
    {
      icon: '/images/emoji/friendly-face.svg',
      title: TITLES.MAKE_IT_MORE_FRIENDLY,
      instruction: INSTRUCTIONS.MAKE_IT_MORE_FRIENDLY,
    },
    {
      icon: '/images/emoji/target.svg',
      title: TITLES.MAKE_IT_MORE_CONFIDENT,
      instruction: INSTRUCTIONS.MAKE_IT_MORE_CONFIDENT,
    },
    {
      icon: '/images/emoji/broom.svg',
      title: TITLES.MAKE_IT_CLEANER,
      instruction: INSTRUCTIONS.MAKE_IT_CLEANER,
    },
    {
      icon: '/images/emoji/dizzy.svg',
      title: TITLES.MAKE_IT_MORE_EXCITING,
      instruction: INSTRUCTIONS.MAKE_IT_MORE_EXCITING,
    },
  ]
}

const getLimitedOptions = (t) => {
  const TITLES = getTitles(t)
  return [
    {
      icon: '/images/emoji/pen.svg',
      title: TITLES.REWRITE_COMPLETELY,
      instruction: INSTRUCTIONS.REWRITE_COMPLETELY,
    },
    {
      icon: '/images/emoji/friendly-face.svg',
      title: TITLES.MAKE_IT_MORE_FRIENDLY,
      instruction: INSTRUCTIONS.MAKE_IT_MORE_FRIENDLY,
    },
    {
      icon: '/images/emoji/target.svg',
      title: TITLES.MAKE_IT_MORE_CONFIDENT,
      instruction: INSTRUCTIONS.MAKE_IT_MORE_CONFIDENT,
    },
  ]
}

const getAllOptions = (t) => [...getRewriteOptions(t), ...getAdjustToneOptions(t), ...getOptions(t)]

const getResultInstructionIcon = (instruction, t) => {
  const allOptions = getAllOptions(t)
  const index = allOptions.findIndex((option) => option.instruction === instruction)

  if (index === -1) {
    return null
  }

  return allOptions[index].icon
}

const getResultInstructionTitle = (instruction, t) => {
  const allOptions = getAllOptions(t)
  const index = allOptions.findIndex((option) => option.instruction === instruction)

  if (index === -1) {
    return null
  }

  return allOptions[index].title
}

export {
  getOptions,
  getRewriteOptions,
  getAdjustToneOptions,
  MAX_SMS_LENGTH,
  MAX_CHARACTERS_LENGTH,
  getLimitedOptions,
  getResultInstructionIcon,
  getResultInstructionTitle,
}
